import React from "react";
import { ListGroup, ListGroupItem } from "reactstrap";
import { isFunction } from "lodash";

const ScooterListItem = ({
  scooter: { license_plate, brand, model, color, vin },
  children
}) => {
  return (
    <ListGroupItem>
      <div className="row justify-content-between align-items-center">
        <div className="col-9">
          <div className="row">
            <div className="col-12">
              <label>{`License Plate: ${license_plate}`}</label>
            </div>
            <div className="col-12">
              <label>{`Vin: ${vin}`}</label>
            </div>
            <div className="col-12">
              <label>{`${brand} - ${model} - ${color}`}</label>
            </div>
          </div>
        </div>
        {children && <div className="col-3">{children}</div>}
      </div>
    </ListGroupItem>
  );
};

const ScooterList = ({ scooters, children }) => {
  return (
    <ListGroup flush>
      {scooters.map((scooter, index) => (
        <ScooterListItem key={scooter.id || index} scooter={scooter}>
          {isFunction(children) && children({ scooter })}
        </ScooterListItem>
      ))}
    </ListGroup>
  );
};

export default ScooterList;
